import { Box, CircularProgress, Typography } from "@mui/material";

type LoadingDisplayProps = { message?: string };

const LoadingDisplay: React.FC<LoadingDisplayProps> = (props) => {
  const { message } = props;

  return (
    <Box sx={{ display: "grid", placeItems: "center", gap: 2, padding: 3 }}>
      <CircularProgress size="3rem" />
      <Typography>{message || "Laddar..."}</Typography>
    </Box>
  );
};

export default LoadingDisplay;
